module.exports = __webpack_public_path__ + "img/26-jeep-cherokee.d680f882.jpg";